import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    tab_loading: false,
    time_loading: false,
    media_type_selected: '',
    image: [],
    video: [],
    upload_file_visibility: false,
    current_media_type: ''
  },
  mutations: {
    INIT_IDLE_SCREEN_SETTING_DIALOG(state, payload) {
      state.media_type_selected = payload.media_type_selected
      state.image = payload.image
      state.video = payload.video
    },
    RESET_IDLE_SCREEN_SETTING_DIALOG(state) {
      state.visibility = false
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_TAB_LOADING(state, payload) {
      state.tab_loading = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_TIME_LOADING(state, payload) {
      state.time_loading = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_MEDIA_TYPE_SELECTED(state, payload) {
      state.media_type_selected = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_IMAGE(state, payload) {
      state.image = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_VIDEO(state, payload) {
      state.video = payload
    },
    SET_IDLE_SCREEN_SETTING_DIALOG_CURRENT_MEDIA_TYPE(state, payload) {
      state.current_media_type = payload
    },

    INIT_IDLE_SCREEN_SETTING_DIALOG_UPLOAD_FILE(state) {
      state.upload_file_visibility = true
    },
    RESET_IDLE_SCREEN_SETTING_DIALOG_UPLOAD_FILE(state) {
      state.upload_file_visibility = false
    }
  },
  actions: {
    async initIdleScreenDialog({ commit }) {
      try {
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_VISIBILITY', true)
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_LOADING', true)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })
        const response = await api.getIdleScreen()
        if (response.data.success) {
          commit('INIT_IDLE_SCREEN_SETTING_DIALOG', response.data.data)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_LOADING', false)
      }
    },
    async fetchIdleScreenMedia({ commit }, payload) {
      try {
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_TAB_LOADING', true)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })
        const response = await api.getIdleScreenMedia({ media_type: payload, params: {} })
        if (response.data.success) {
          if (payload === 'image') commit('SET_IDLE_SCREEN_SETTING_DIALOG_IMAGE', response.data.data)
          if (payload === 'video') commit('SET_IDLE_SCREEN_SETTING_DIALOG_VIDEO', response.data.data)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_TAB_LOADING', false)
      }
    },

    async updateIdleScreen({ rootState, commit }, payload) {
      try {
        if (payload.type === 'media_type_selected') commit('SET_IDLE_SCREEN_SETTING_DIALOG_LOADING', true)
        else if (payload.type === 'duration') commit('SET_IDLE_SCREEN_SETTING_DIALOG_TIME_LOADING', true)

        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })

        const params = { device_id: rootState.auth.selected_device, ...payload.param }
        const response = await api.updateIdleScreen({ params: params })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_LOADING', false)
        commit('SET_IDLE_SCREEN_SETTING_DIALOG_TIME_LOADING', false)
      }
    },

    async uploadIdleScreenSettingDialogMedia({ rootState, state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', ''), loading: true })

        const form_data = new FormData()
        form_data.append('device_id', rootState.auth.selected_device)
        form_data.append('media_type', state.current_media_type)
        payload.files.forEach((file) => {
          form_data.append('files', file)
        })

        const response = await api.uploadIdleScreenMediaFile({ params: form_data })
        if (response.data.success) {
          dispatch('fetchIdleScreenMedia', state.current_media_type)
          commit('RESET_IDLE_SCREEN_SETTING_DIALOG_UPLOAD_FILE')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.upload', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async deleteIdleScreenMedia({ rootState, state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.deleting', ''), loading: true })
        let params = {}
        params.device_id = rootState.auth.selected_device
        if (payload.media_type === 'image') params.image_id = payload.image_id
        if (payload.media_type === 'video') params.video_id = payload.video_id

        const response = await api.deleteIdleScreen({ params: params })
        if (response.data.success) {
          dispatch('fetchIdleScreenMedia', state.current_media_type)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.delete', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
